import React, { useState, useEffect } from 'react';
import { User } from 'firebase/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/shadcn/ui/card';
import { Button } from '@/components/shadcn/ui/button';
import useFirebase from '@/hook/useFirebase';
import { useColaborator } from '@/hook/useColaborator';


// Interfaces para Company e Role
interface Company {
  id: number;
  fantasyName: string;
}

interface Role {
  id: number;
  name: string;
}

// Props para o componente
interface SelectCompanyAndRoleProps {
  user: User | null;
}

const SelectCompanyAndRole: React.FC<SelectCompanyAndRoleProps> = () => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const {createUser} = useFirebase();
  const [roles, setRoles] = useState<Role[]>([]);
  const location = useLocation();
  const { userEmail, userName, userPassword } = location.state || {};
  const [selectedCompany, setSelectedCompany] = useState<Company | null>(null);
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
  const {createColaborator} = useColaborator();
  const navigate = useNavigate();

  const registerFirebase = async (email: string, password : string, displayName : string ) => {
    const response = await createUser(email,password,displayName)
  }
  
  const API_URL = "/ws/api";

  // Carregar as empresas e funções
  useEffect(() => {
    

    fetch(`${API_URL}/api/companies-roles`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erro ao carregar companies e roles');
        }
        return response.json();
      })
      .then((data) => {
        setCompanies(data.companies);
        setRoles(data.roles);
      })
      .catch((err) => console.error(err));
  }, []);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();


      const userData = {
        email: userEmail,
        name: userName,
        companyId: selectedCompany?.id,
        roleId: selectedRole?.id,
      };

      const registerResponse = await fetch(`${API_URL}/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData),
      });

      if (!registerResponse.ok) {
        throw new Error('Erro ao registrar usuário');
      }

      registerFirebase(userEmail,userPassword,userName);

      alert('Cadastro realizado com sucesso!');
      navigate("/kanban");

  };

  

  return (
    <div className="flex min-h-screen bg-indigo-200 justify-center items-center">
      <Card className="w-[450px] h-[550px]">
        <CardHeader>
          <CardTitle>Selecione sua empresa</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <div className="grid w-full items-center gap-6">
              {/* Seleção de empresa */}
              <div className="flex flex-col space-y-1.5">
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Empresa:</label>
                <select
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  value={selectedCompany?.id || ''}
                  onChange={(e) => {
                    const company = companies.find(
                      (c) => c.id === Number(e.target.value)
                    );
                    setSelectedCompany(company || null);
                  }}
                >
                  <option value="">Escolha uma empresa</option>
                  {companies.map((company) => (
                    <option key={company.id} value={company.id}>
                      {company.fantasyName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Seleção de função */}
              <div className="flex flex-col space-y-1.5">
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Função:</label>
                <select
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  value={selectedRole?.id || ''}
                  onChange={(e) => {
                    const role = roles.find(
                      (r) => r.id === Number(e.target.value)
                    );
                    setSelectedRole(role || null);
                  }}
                >
                  <option value="">Escolha uma função</option>
                  {roles.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Botão de cadastrar */}
              <CardFooter className="mt-4 flex justify-center">
                <Button
                  type="submit"
                  className="bg-indigo-500 hover:bg-indigo-800 w-[130px]"
                >
                  Cadastrar
                </Button>
              </CardFooter>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default SelectCompanyAndRole;
